module.exports = __webpack_public_path__ + "img/mm_b1_img1.eb4d7921.png";